<mat-toolbar>
  <div class="footer-content">
    <div class="footer-links" style="flex-wrap: wrap;">
      <div style="padding-right: 2px;">{{appName}}</div>
      <div style="padding-left: 2px; padding-right: 2px;">v{{appVersion}}</div>
      <div style="padding-left: 2px;">{{appCopyright}}</div>
    </div>
    <div class="footer-links">
      <div style="padding-left: 12px; padding-right: 2px;"><a href="terms-of-use.html" target="_blank" rel="noopener noreferrer" style="color: #fff">Terms of Use</a></div>
      <div style="padding-left: 2px; padding-right: 2px;"><span>-</span></div>
      <div style="padding-left: 2px; padding-right: 4px;"><a href="privacy-policy.html" target="_blank" rel="noopener noreferrer" style="color: #fff">Privacy Policy</a></div>
    </div>
  </div>
</mat-toolbar>
